import styles from "./MotherChurch.module.scss";
import iconStyles from "../../../components/Icon.module.scss";
import buttonStyles from "../../../components/Button.module.scss";

const MotherChurch = () => {
  return (
    <section id="mother-church" className={styles["mother-church"]}>
      <div className={styles.wrapper}>
        <div className={styles.desc}>
          <h5>Our mother church</h5>
          <p>
            Our church is under the synod of Reformed Evangelical Church of
            Indonesia (known as Gereja Reformed Injili Indonesia or GRII)
            started by Rev. Dr. Stephen Tong.
          </p>

          <a
            href="https://pusat.grii.org/"
            className={`${buttonStyles.button}`}
            target="_blank"
            rel="noreferrer"
          >
            Learn more
            <i
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.launch}`}
            ></i>
          </a>
        </div>
        <div
          className={styles.img}
          style={{
            backgroundImage: "url(mother_church.png)",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </div>
    </section>
  );
};

export default MotherChurch;
